export class PathwayConstants {
    static notes_several_courses = "Either course fulfills this requirement";
    static non_k12_course = { "courseId": -1, "courseName": "Non K12 Course"};
    static unsaved_message = "You have un-saved changes for the current pathway's requirements. Do you want to continue without saving the changes?";
    static errors =
        {
            courseId: {
                required: 'Course is a required field for the pathway requirement. Please enter/select a course from the available list.',
                cleanRequired: 'Course is a required field for the pathway requirement. Please enter/select a course from the available list.'
            },
            name: {
                courseNameRequired: 'Course Name is a required field when using a non-K12 course in the pathway requirement. Please enter a course name.',
                duplicateCourse: 'A course has been assigned multiple times for the pathway. Please select a different course to proceed.'
            },
            settings: {
                participatorCount: 'Participator setting shall be left empty when no course requirements are defined.',
                participatorInvalid: 'Invalid value for the Participator setting. Please enter a non-zero value that is less than the Concentrator setting.',
                participatorCompletorInvalid: 'Invalid value for the Participator setting. Please enter a non-zero value that is less than the Completer setting.',

                concentratorCount: 'Concentrator setting shall be left empty when no course requirements are defined.',
                concentratorInvalid: 'Invalid value for the Concentrator setting. Please enter a non-zero value that is less than the Completer setting.',

                completorCount: 'Completer setting shall be left empty when no course requirements are defined.',
                completorRequired: 'Completer setting is required when course requirements are defined.',
                completorInvalid: 'Invalid value for the Completer setting. Please enter a non-zero value that is less than or equal to the number of required courses.', 
            
                invalidSettings: 'Invalid value for the Participator/Concentrator/Completer setting. Please enter a non-zero and numeric value.'
            }
        }
}
